module.exports = __webpack_public_path__ + "static/FSDG-1-1401fb9d8fe7f4d5e6d1ca686e78a83f.jpg";